import { useTranslation } from "react-i18next";

import { useBillingAccountAccess } from "@/hooks/useBillingAccountAccess";

const labelKeys = {
  billingAccounts: "user-account.tabs.billingRecipients",
  default: "user-account.tabs.paymentMethods",
} as const;

/** Business invoice customers manage Rechnungsempfänger instead of a payment method. */
export const usePaymentsTabLabel = () => {
  const { t } = useTranslation("portal");
  const { hasBillingAccounts } = useBillingAccountAccess();

  return t(labelKeys[hasBillingAccounts ? "billingAccounts" : "default"]);
};
